import { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import CardStyle from './tabs/CardStyle';
import ThemeStyle from './tabs/ThemeStyle';
import FontStyle from './tabs/FontStyle';
import Preview from './tabs/Preview';

import {
  MainContainer, Tabs, MainColumn, TabItem, ScrollContainer,
} from './styled/DashStyles.styled';

const DashStyles = ({
  tempStylesDataState = [{}, () => {}],
}) => {
  const cron = useRef();
  const [tab, setTab] = useState('CARD');
  const [tempStylesData, setTempStylesData] = tempStylesDataState;

  const handleTmpStyle = (key, value) => {
    setTempStylesData((o) => ({
      ...o,
      [key]: value,
    }));
  };

  const handleTimedTmpStyle = (key, value) => {
    clearTimeout(cron.current);
    cron.current = setTimeout(() => {
      handleTmpStyle(key, value);
    }, 200);
  };

  return (
    <MainContainer>
      <Preview tmpStyle={tempStylesData} />
      <MainColumn>
        <Tabs>
          <TabItem onClick={() => setTab('CARD')} active={tab === 'CARD'}>
            Cards
          </TabItem>
          <TabItem onClick={() => setTab('THEME')} active={tab === 'THEME'}>
            Temas
          </TabItem>
          <TabItem onClick={() => setTab('FONT')} active={tab === 'FONT'}>
            Fontes
          </TabItem>
        </Tabs>
        <ScrollContainer>
          {tab === 'CARD' && (
            <CardStyle
              tmpData={tempStylesData}
              handler={handleTmpStyle}
              timedHandler={handleTimedTmpStyle}
            />
          )}
          {tab === 'THEME' && (
            <ThemeStyle
              tmpData={tempStylesData}
              handler={handleTmpStyle}
              timedHandler={handleTimedTmpStyle}
            />
          )}
          {tab === 'FONT' && (
            <FontStyle
              tmpData={tempStylesData}
              handler={handleTmpStyle}
              timedHandler={handleTimedTmpStyle}
            />
          )}
        </ScrollContainer>
      </MainColumn>
    </MainContainer>
  );
};

DashStyles.propTypes = {
  tempStylesDataState: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  ),
};

export default DashStyles;
